exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-dialog-modal .modal-body{max-height:50vh;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib?{"loaders":{"js":"babel-loader"}}!./galaxy/scripts/components/DataDialog.vue?vue&type=style&index=0&lang=css
// module id = 188
// module chunks = 0 2 3